import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_a3709e67-7648-4bcb-a123-219697b944ef/artifacts/aqwsfdgh_Martin_Aagaard_-_Kystlandskap_-_IMG_9313.jpg';

export default function Landing() {
  const [painted, setPainted] = useState(false);

  // Reveal the animated painting only after it has had time to unpack/render,
  // so the (identical) static image covers the loader chrome on refresh.
  useEffect(() => {
    const t = setTimeout(() => setPainted(true), 2600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen" data-testid="landing-page">
      {/* Hero Section - Full screen, minimal */}
      <section className="relative min-h-screen overflow-hidden">
        {/* Static painting as instant fallback (shown until the animation renders) */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        />

        {/* Living Painting - same image, lightly animated (full-bleed background) */}
        <iframe
          src={`${process.env.PUBLIC_URL || ''}/living-painting.html`}
          title="Coastwise"
          aria-hidden="true"
          tabIndex={-1}
          scrolling="no"
          className="living-cover"
          style={{ opacity: painted ? 1 : 0, transition: 'opacity 600ms ease' }}
          data-testid="living-painting-bg"
        />

        {/* Dark gradient at top */}
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{ 
            background: 'linear-gradient(to bottom, rgba(10, 22, 40, 0.6) 0%, rgba(10, 22, 40, 0.15) 35%, transparent 50%, rgba(10, 22, 40, 0.25) 100%)' 
          }}
        />
        
        {/* Logo - upper left */}
        <div className="absolute top-0 left-0 p-8 md:p-12 z-10">
          <h1 className="text-xl md:text-2xl text-white tracking-[0.3em] font-medium drop-shadow-lg">
            COASTWISE TRADE
          </h1>
        </div>
        
        {/* Enter - bottom right */}
        <div className="absolute bottom-0 right-0 p-8 md:p-12 z-10">
          <Link 
            to="/enter" 
            className="text-white text-lg font-medium tracking-wider hover:opacity-80 transition-opacity drop-shadow-lg"
            data-testid="enter-button"
          >
            Enter →
          </Link>
        </div>
      </section>
    </div>
  );
}
